"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
class QueryListItem extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(reactstrap_1.Card, { tag: this.props.url ? react_router_dom_1.Link : undefined, body: this.props.itemPadding !== false, className: classnames_1.default('mb-2 query-list-item'), to: this.props.url ? this.props.url : undefined, onClick: () => this.props.onClick && this.props.onClick(), "data-cy": "query-list-item" }, this.props.children));
    }
}
exports.QueryListItem = QueryListItem;
//# sourceMappingURL=QueryListItem.js.map